import React from 'react'
import { Button } from 'reactstrap'

export default function DeleteButton({handleDelete}) {
  if(handleDelete) {
    return (
      <Button onClick={handleDelete} size="sm" color="warning">Delete</Button>
    )
  }
  return null;
}
